import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();
  const items: string[] = t('trust.items', { returnObjects: true }) as unknown as string[];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left - Text */}
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              {t('trust.title')}
            </h2>
            <div className="space-y-4">
              {items.map((item: string, idx: number) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-shield-check-line text-accent-600 text-sm w-4 h-4 flex items-center justify-center"></i>
                  </div>
                  <span className="text-sm text-foreground-700">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Quality%20inspection%20workspace%20with%20hands%20holding%20magnifying%20glass%20over%20product%20tag%20and%20fabric%20swatches%20on%20light%20oak%20desk%20with%20notebook%20pen%20and%20smartphone%20showing%20checklist%20soft%20diffused%20natural%20light%20from%20large%20window%20clean%20organized%20professional%20setting%20editorial%20photography%20with%20warm%20ivory%20tones%20and%20calm%20focused%20atmosphere&width=800&height=600&seq=kakobuy-trust-v2-2026&orientation=landscape"
                alt="Kakobuy Spreadsheet - zaufany przewodnik"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-accent-100 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}